import { action } from 'satcheljs';

/**
 * Updates the Event Body using the uiState
 */
export const setEventBodyFromViewState = action('setEventBodyFromViewState', (formId: string) => ({
    formId,
}));
